import Head from "next/head";
import { LandingPageProps } from "./types";

const PreloadImages = (pageProps: LandingPageProps) => {
  return (
    <Head>
      {pageProps?.data?.claimSettlementText?.icon && (
        <link
          rel="preload"
          href={`${pageProps.data.claimSettlementText.icon}`}
          as="image"
        />
      )}

      {pageProps?.data?.travelSearchBanner?.icon && (
        <link
          rel="preload"
          href={`${pageProps.data.travelSearchBanner.icon}`}
          as="image"
        />
      )}

      {pageProps?.data?.secureTravData?.[0]?.travImg && (
        <link
          rel="preload"
          href={`${pageProps.data.secureTravData[0].travImg}`}
          as="image"
        />
      )}

      {pageProps?.data?.secureTravData?.[1]?.travImg && (
        <link
          rel="preload"
          href={`${pageProps.data.secureTravData?.[1].travImg}`}
          as="image"
        />
      )}

      <link
        rel="preload"
        href="https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg"
        as="image"
      />
      <link
        rel="preload"
        href="https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg"
        as="image"
      />
    </Head>
  );
};

export default PreloadImages;
